export default {"src":"/_next/static/media/close-search.935f01a9.svg","height":15,"width":15};